<template>
    <div style="background:#FFF">
        <CCol sm="12" class="p-2">
            <CRow>
                <CCol sm="4">
                   <CCard class="border-12px">
                        <CRow>
                            <CCol sm="12">
                            <div class="p-3 custom-bg-purple">
                                <h3 class="custom-18px-600 text-left mt-3 text-white">
                                    Total Expenses
                                </h3><h4 class="custom-12px-400 text-white">Details of expenses during this period</h4>
                                <h2 class="custom-30px-600 text-white">MYR 0</h2>
                                <h4 class="custom-14px-500 text-white">+ MYR 0 than last month</h4>
                                </div>
                            </CCol>
                            <CCol sm="6" class="">
                                 <div class="text-white ml-3 mt-3">
                                <h3 class="custom-16px-500">View Report</h3>
                            </div>
                            </CCol>
                            <CCol sm="5" class="">
                                <div class="text-right mt-3 mr-1">
                                 <img src="../assets/img/smallicon/ArrowUpRight.png" width="20px"/>
                                 </div>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCol>

                <CCol sm="4">
                <CCard class="border-12px">
                        <CRow>
                            <CCol sm="12">
                            <div class="p-3 custom-bg-blue">
                                <h3 class="custom-18px-600 text-left mt-3 text-white">
                                   Total Income
                                </h3><h4 class="custom-12px-400 text-white">Revenue analytics for this period</h4>
                                <h2 class="custom-30px-600 text-white">MYR {{ totalIncome.TotalIncome}}</h2>
                                <h4 class="custom-14px-500 text-white">+ MYR {{ totalIncome.CurrentMonthIncome }} than last month</h4>
                                </div>
                            </CCol>
                              <CCol sm="6" class="">
                                 <div class="text-white ml-3 mt-3">
                                <h3 class="custom-16px-500">View Report</h3>
                            </div>
                            </CCol>
                            <CCol sm="5" class="">
                                <div class="text-right mt-3 mr-1">
                                 <img src="../assets/img/smallicon/ArrowUpRight.png" width="20px"/>
                                </div>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCol>

                <CCol sm="4">
                 <CCard class="border-12px">
                        <CRow>
                            <CCol sm="12">
                            <div class="p-3 custom-bg-green">
                                <h3 class="custom-18px-600 text-left mt-3 text-white">
                                   Total Team
                                </h3><h4 class="custom-12px-400 text-white">New Team who joined during this period.</h4>
                                <h2 class="custom-30px-600 text-white">Total {{ totalTeam.TotalTeamCount }}</h2>
                                <h4 class="custom-14px-500 text-white">+ {{totalTeam.CurrentMonthTeamCount}} than last month</h4>
                                </div>
                            </CCol>
                              <CCol sm="6" class="">
                                 <div class="text-white ml-3 mt-3">
                                <h3 class="custom-16px-500">View Report</h3>
                            </div>
                            </CCol>
                            <CCol sm="5" class="">
                                <div class="text-right mt-3 mr-1">
                                <img src="../assets/img/smallicon/ArrowUpRight.png" width="20px"/>
                                </div>
                            </CCol>
                        </CRow>
                    </CCard>
                </CCol>

                <CCol sm="6">
                    <CCard class="border-12px">
                        <div v-if="tour && tour.length > 0">
                            <CRow class="p-2" v-for="(item, index) in tour.slice(0, 1)" :key="item.Id">
                                <CCol sm="2">
                                    <div class="text-center">
                                    <img src="../assets/img/defaultteam.png" style="max-width:100%" />

                    
                                    </div>
                                </CCol>
                                <CCol sm="10">
                                    <h3 class="custom-20px-600 text-left">{{ item.Title }}</h3>
                                    <CRow>
                                        <CCol sm="12">
                                            <img src="../assets/img/smallicon/Location.png" width="20px"/>
                                            <label class="custom-14px-400 font-color-064BB4 text-left">{{ item.Location }}</label>
                                        </CCol>
                                    
                                    </CRow>
                                </CCol>
                                <CCol sm="12">
                                    <CRow class="mt-5">
                                        <CCol sm="4">
                                            <h3 class="custom-14px-500">Operating Hours</h3>
                                        </CCol>
                                        <CCol sm="8"> <h3 class="custom-14px-500">{{ item.start}} - {{item.end }}</h3></CCol>
                                        <CCol sm="4">
                                            <h3 class="custom-14px-500">Organizer</h3>
                                        </CCol>
                                        <CCol sm="8"> <h3 class="custom-14px-500">{{ item.Organizer}}</h3></CCol>
                                        <CCol sm="4">
                                            <h3 class="custom-14px-500">Category</h3>
                                        </CCol>
                                        <CCol sm="8"> <h3 class="custom-14px-500">{{ item.Category}}</h3></CCol>
                                        <CCol sm="4">
                                            <h3 class="custom-14px-500">Amount</h3>
                                        </CCol>
                                        <CCol sm="8"> <h3 class="custom-14px-500">RM {{ item.Amount}}</h3></CCol>
                                        <CCol sm="4">
                                            <h3 class="custom-14px-500">Terms & Condition</h3>
                                        </CCol>
                                        <CCol sm="8">
                                        
                                            <a class="custom-14px-500" @click="downloadRule(item.FilePathTerms)" style="color:blue">Rules and Regulation</a></CCol>
                                    </CRow>
                                </CCol>
                                
                            </CRow>
                        </div>
                        <CRow v-else class="text-center custom-scroll-div">
                        <CCol>
                            <img src="../assets/img/nodata.png" alt="No Data" style="max-width:200px; margin:auto;" />
                        </CCol>
                    </CRow>
                   
                    </CCard>
                </CCol>
                <CCol sm="6">
                    <h3 class="custom-20px-600 font-color-171717">Member Payment List</h3>
                    <div class="custom-scroll-div" v-if="participant && participant.length > 0">
                    <table class="table p-20 table-responsive-sm">
                        <thead style="background-color: #F9FAFB;color:#737373">
                            <th>Month</th>
                            <th>Team Name</th>
                            <th>Phone</th>
                            <th>Status</th>
                        </thead>
                        <tbody v-for="(item,index) in participant" v-bind:key="item.Id">
                            <tr>
                                <td><label style="white-space: nowrap;">{{ item.CreatedDate | moment("MMM YYYY")}}</label></td>
                                <td>{{item.TeamName}}</td>
                                <td>{{ item.PhoneNumber}}</td>
                                <td><span class="custom-badge-success">Paid</span></td>
                               
                            </tr>
                           
                        </tbody>

                    </table>
                    </div>
                    <CRow v-else class="text-center custom-scroll-div">
                        <CCol>
                            <img src="../assets/img/nodata.png" alt="No Data" style="max-width:200px; margin:auto;" />
                        </CCol>
                    </CRow>
                </CCol>
                <CCol sm="12">
                    <h3 class="custom-20px-600 font-color-171717">Club Member Details</h3>
                    <div class="custom-scroll-div" v-if="participant && participant.length > 0">
                        <table class="table p-20 table-responsive-sm">
                            <thead style="background-color: #F9FAFB;color:#737373">
                                <th>Name</th>
                                <th>Role</th>
                                <th>Phone Number</th>
                                <th>Email</th>
                                <th>Status</th>
                            </thead>
                            <tbody v-for="(item,index) in participant" v-bind:key="item.Id">
                                <tr>
                                    <td>{{ item.ManagerName}}</td>
                                    <td>Manager</td>
                                    <td>{{ item.PhoneNumber}}</td>
                                    <td>{{ item.Email}}</td>
                                    <td><span class="custom-badge-success">Active</span></td>
                                
                                </tr>
                            
                            </tbody>

                        </table>
                    </div>
                    <CRow v-else class="text-center custom-scroll-div">
                        <CCol>
                            <img src="../assets/img/nodata.png" alt="No Data" style="max-width:200px; margin:auto;" />
                          
                        </CCol>
                    </CRow>
                </CCol>
            </CRow>
        </CCol>
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";
import moment from "moment";
Vue.use(require("vue-moment"));
Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/Membership.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundGenie from "../assets/img/bggenie.png";
import backgroundUrNoArrow from "../assets/img/bg.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import ToggleCard from '../components/Toggle.vue';

import msalInstance from '../containers/msalService';

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,
    },
    data() {
        return {
            backgroundUrl,
            backgroundUrNoArrow,

            backgroundGenie,
            isActive: false,
            tour: [],
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth(),
            daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            participant: [],
            totalTeam: {},
            totalIncome: {}

        };
    },
    created() {
        AOS.init();

    },
    watch: {
        '$i18n.locale': {
            immediate: true,
            handler() {
                this.$forceUpdate(); // Forces re-render on language change
            }
        }
    },
    computed: {
        CreationDate() {
            return moment().startOf('day'); // Start of today
        },
        daysInMonth() {
            const days = [];
            const date = new Date(this.currentYear, this.currentMonth, 1);

            // Adjust start date to Sunday of the week
            date.setDate(date.getDate() - date.getDay());

            // Loop through each day in the calendar grid (5-6 weeks typically)
            for (let i = 0; i < 42; i++) {
                const dayEvents = this.getEventsForDate(date);
                days.push({ date: new Date(date), events: dayEvents });
                date.setDate(date.getDate() + 1); // Go to next day
            }
            return days;
        },
        monthName() {
            return new Date(this.currentYear, this.currentMonth).toLocaleString("default", { month: "long" });
        }
    },
    async mounted() {

        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {
                await this.GetInfoUser();
               await this.GetListTour();
               await this.GetListPartipantPayment();
               await this.GetDashboardTotalTeam();
               await this.GetDashboardTotalIncome();
            } else {
                this.GoToLogin();
            }
        } catch (error) {
            this.GoToLogin();
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    methods: {
          async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    this.filePath = response.data.filePath;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        isTimeAfterToday(time) {
            const itemTime = moment(time).startOf('day');
            return itemTime.isAfter(this.CreationDate);
        },
        toggle() {
            this.isActive = !this.isActive;
        },
        GetListTour() {
            this.$API
                .get(this.$GetListTournamentByUserId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.tour = response.data;
                        this.getThumbnail(this.tour.FilePath);
                    }
                });
        },
        GetListPartipantPayment() {
            this.$API
                .get(this.$GetListParticipantByOrganizerUserId, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.participant = response.data;
                        this.totalTeamCount = this.participant.length;
                    }
                });
        },
        GetDashboardTotalTeam() {
            this.$API
                .get(this.$GetDashboardTotalTeam, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.totalTeam = response.data;
                    }
                });
        },
        GetDashboardTotalIncome() {
            this.$API
                .get(this.$GetDashboardTotalIncome, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200 && response.data != null) {
                        this.totalIncome = response.data;

                    }
                });
        },
        getThumbnail(index) {
            return (
                "https://sportcenter.s3.ap-southeast-1.amazonaws.com/" + this.tour[index].FilePath
            );
        },
        GoToDetail(id) {
            this.$router.push("RegisterGames?id=" + id);
        },
        getEventsForDate(date) {
            // Get events that match the specific day
            return this.tour.filter(event => {
                const eventDate = new Date(event.Start);
                return (
                    eventDate.getFullYear() === date.getFullYear() &&
                    eventDate.getMonth() === date.getMonth() &&
                    eventDate.getDate() === date.getDate()
                );
            });
        },
        isToday(date) {
            const today = new Date();
            return (
                today.getFullYear() === date.getFullYear() &&
                today.getMonth() === date.getMonth() &&
                today.getDate() === date.getDate()
            );
        },
        previousMonth() {
            if (this.currentMonth === 0) {
                this.currentMonth = 11;
                this.currentYear--;
            } else {
                this.currentMonth--;
            }
        },
        nextMonth() {
            if (this.currentMonth === 11) {
                this.currentMonth = 0;
                this.currentYear++;
            } else {
                this.currentMonth++;
            }
        },
        GoToEvent()
        {
            this.$router.push("CreateEvent");
        },
        downloadRule(terms) {
            console.log("tt" + terms);
            const pdfURL = 'https://sportcenter.s3.ap-southeast-1.amazonaws.com/' + terms;

            // Create an anchor element
            const link = document.createElement('a');
            link.href = pdfURL;
            link.target = '_blank';

            // Set the download attribute to force download
            link.setAttribute('download', terms);

            // Append the anchor element to the body
            document.body.appendChild(link);

            // Trigger a click event on the anchor element
            link.click();

            // Clean up by removing the anchor element
            document.body.removeChild(link);
        },





    }



};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans&display=swap');
body {
    top: 0 !important;
    font-family: 'Poppins', sans-serif;
}
.image-container {
  position: relative;
  display: inline-block;
  max-width: 100%;
  border-radius: 20px;
}

/* Style the image */
.image {
  display: block;
  max-width: 100%;
  border-radius: 20px;
}

/* Style the overlay text */
.overlay-text-right {
  position: absolute;
  top: 10px; /* Adjust the vertical position */
  right: 10px; /* Adjust the horizontal position */
  background: #fff; /* Optional: background for better readability */
  color: #064BB4; /* Text color */
  padding: 5px 10px; /* Padding around the text */
  border-radius: 5px; /* Optional: rounded corners */
  font-size: 14px; /* Adjust the font size */
}
.overlay-text-left {
  position: absolute;
  top: 10px; /* Adjust the vertical position */
  left: 10px; /* Adjust the horizontal position */
  background: #064BB4; /* Optional: background for better readability */
  color: #fff; /* Text color */
  padding: 5px 10px; /* Padding around the text */
  border-radius: 5px; /* Optional: rounded corners */
  font-size: 14px; /* Adjust the font size */
}
</style>